export const defaultAttachmentFileNameStyles = {
  minHeight: "15px",
  marginLeft: "5px",
  marginRight: "5px",
  color: "#000000 !important"
};